<template>
    <scroll-area>
        <template slot="body">
                <v-layout  column fill-height justify-start>
                    <v-layout v-if="!isEdit"  fill-height justify-start>
                        <v-flex xs6 v-if="getFields">
                            <v-layout column fill-height v-if="getFields" justify-start px-0>
                                <v-layout shrink v-for="(field, name) in getFields" :key="'text' + name" v-if="field.value && field.place == 'main' && (field.type == 'text' || field.type == 'integer' || field.type == 'timestamp')" pa-0>
                                    <v-flex xs4 v-if="field.value && field.show" shrink px-0 pb-2>      
                                        <v-text-field
                                            :value="$t(field.name)"
                                            light
                                            outline                                         
                                            flat
                                            readonly
                                            disabled
                                            class="backgrey"
                                            hide-details
                                            :rows="1"
                                            color="white"
                                        >                   
                                        </v-text-field>
                                    </v-flex>

                                    <v-flex xs8 v-if="field.value && field.show" shrink px-0 pb-2>          
                                        <v-text-field
                                            v-if="field.type == 'timestamp'"
                                            :value="showDate(model.fields[field.name].value)"
                                            readonly
                                            light
                                            auto-grow
                                            outline                                                                                   
                                            class="white"
                                            hide-details
                                            rows="1"
                                            color="accent"
                                        ></v-text-field>
                                        
                                        <v-text-field
                                            v-if="field.type != 'timestamp'"
                                            :value="$t(field.value)"
                                            readonly
                                            light
                                            auto-grow
                                            outline                                           
                                            class="white"                
                                            hide-details
                                            :rows="1"
                                            color="accent"
                                        >                     
                                        </v-text-field>
                                    </v-flex> 
                                </v-layout>     
                            </v-layout>
                        </v-flex>

                        <v-flex xs6 v-if="getFields" px-2>
                            <v-layout column fill-height v-if="getFields" justify-start px-0>
                                <v-layout shrink v-for="(field, name) in getFields" :key= " 'select' + name" v-if="field.place == 'main' && (field.type == 'select' || field.type == 'select_enum')" pa-0>
                                    <v-flex xs4 v-if="field.value && field.show" shrink px-0 pb-2>                     
                                        <v-text-field
                                            :value="$t(field.name)"
                                            light
                                            auto-grow
                                            outline                                         
                                            class="backgrey" 
                                            disabled                                        
                                            hide-details
                                            :rows="1"
                                            color="grey"
                                        >                   
                                        </v-text-field>
                                    </v-flex>

                                    <v-flex xs8 v-if="field.value && field.show" shrink px-0 pb-2>
                                        <v-text-field
                                            :value="$t(field.value)"
                                            readonly
                                            light
                                            auto-grow
                                            outline        
                                            class="white"
                                            hide-details
                                            :rows="1"
                                            color="accent"
                                        >                     
                                        </v-text-field>
                                    </v-flex>
                                </v-layout>
                            </v-layout>
                        </v-flex>
                    </v-layout>

                    <v-layout column v-if="isEdit" fill-height justify-start pt-0>
                        <v-form ref="inventory-device-form" style="height: 100%">
                            <v-flex shrink mt-1>
                                <v-flex xs12>
                                    <v-layout row v-if="getFields" justify-space-between align-center class="white" >
                                        <v-flex xs12 v-for="(field, name) in getFields" :key="name" v-if="field.place == 'main' && field.show == 'true' && field.type == 'timestamp'">
                                        <date-picker
                                            :value="model.obj[field.name]"
                                            :label="field.name"
                                            @dateChange="(payload) => {onDateChange(payload, field.name)}"
                                        />
                                        </v-flex>
                                    </v-layout>
                                </v-flex>
                            </v-flex>

                            <v-layout row justify-start align-start ma-0>
                                <v-flex xs6 pt-0>
                                    <v-layout column fill-height v-if="getFields" ma-0>
                                        <v-flex v-for="(field, name) in getFields" :key="name" v-show="field.show == 'true' && field.place == 'main' && (field.type == 'text' || field.type == 'integer') && field.name != 'position'" pt-1>
                                            <v-flex v-if="!field.fields" shrink px-0 >
                                                <v-layout shrink px-2>
                                                    <v-flex xs5 shrink px-0 pb-2>
                                                        <v-text-field
                                                            :value="$t(field.name)"
                                                            light
                                                            outline                                                            
                                                            flat
                                                            readonly
                                                            disabled
                                                            class="backgrey"                                                           
                                                            hide-details
                                                            :rows="1"
                                                            color="white"
                                                        >
                                                        </v-text-field>
                                                    </v-flex>

                                                    <v-flex xs7 shrink px-0 pb-2>
                                                        <v-text-field
                                                            v-if="field.type == 'integer'"
                                                            v-model.number="model.obj[field.name]"
                                                            :type="'number'"
                                                            light
                                                            auto-grow
                                                            :rules="model.fields[field.name] && model.fields[field.name].required ? [value => !!value || $t('required')] : []"
                                                            outline                                                           
                                                            class="white"                                                            
                                                            hide-details
                                                            :rows="1"
                                                            color="accent"
                                                        >
                                                        </v-text-field>

                                                        <v-text-field :data-testid="$options.name + 'v-text-field' + field.name"
                                                            v-else
                                                            v-model="model.obj[field.name]"
                                                            light
                                                            auto-grow
                                                            :rules="model.fields[field.name] && model.fields[field.name].required ? [value => !!value || $t('required')] : []"
                                                            outline
                                                            class="white"                                                           
                                                            hide-details
                                                            :rows="1"
                                                            color="accent"
                                                        >
                                                        </v-text-field>
                                                    </v-flex>
                                                </v-layout>
                                            </v-flex>

                                            <v-flex v-if="field.fields" shrink px-0 >
                                                <v-flex v-for="(sfield, name) in field.fields" :key="'s' + name" v-show="sfield.show == 'true' && sfield.place == 'main' && sfield.name != 'name'" pt-1>
                                                    <v-layout shrink v-if="sfield.type == 'text' || sfield.type == 'integer'" px-2>
                                                        <v-flex xs5 shrink px-0 pb-2>
                                                            <v-text-field
                                                                :value="$t(sfield.name)"
                                                                light
                                                                outline                                                            
                                                                flat
                                                                readonly
                                                                disabled
                                                                class="backgrey"                                                          
                                                                hide-details
                                                                :rows="1"
                                                                color="white"
                                                            >
                                                            </v-text-field>
                                                        </v-flex>

                                                        <v-flex xs7 shrink px-0 pb-2>      
                                                            <v-text-field
                                                                v-if="sfield.type == 'integer'"
                                                                v-model.number="model.obj[field.name][sfield.name]"
                                                                :type="'number'"
                                                                light
                                                                auto-grow
                                                                outline                                                            
                                                                class="white"                                                           
                                                                hide-details
                                                                :rows="1"
                                                                color="accent"
                                                            >
                                                            </v-text-field>

                                                            <v-text-field :data-testid="$options.name + 'v-text-field' + sfield.name"
                                                                v-else
                                                                v-model="model.obj[field.name][sfield.name]"
                                                                light
                                                                auto-grow
                                                                outline                                                           
                                                                class="white"                                                            
                                                                hide-details
                                                                :rows="1"
                                                                color="accent"
                                                            >

                                                            </v-text-field>
                                                        </v-flex>
                                                    </v-layout>
                                                    <v-checkbox :data-testid="$options.name + 'v-checkbox' + sfield.name" v-if="sfield.type == 'boolean'" small light color="secondary" v-model="model.obj[field.name][sfield.name]">
                                                        <template v-slot:label>
                                                            <span class="black--text">{{$t(sfield.name)}}</span>
                                                        </template>
                                                    </v-checkbox>
                                                </v-flex>
                                            </v-flex>
                                        </v-flex>

                                        <v-flex xs12 v-for="(field, name) in getFields" :key="'boolean' + name" v-if="field.show == 'true' && field.type == 'boolean' && field.place == 'main'" pl-2>
                                            <v-checkbox :data-testid="$options.name + 'v-checkbox' + field.name" small light color="secondary" v-model="model.obj[field.name]">
                                                <template v-slot:label>
                                                    <span class="black--text" v-if="model.fields[field.name] && model.fields[field.name].required">{{$t(field.name) + ' *'}}</span>
                                                    <span class="black--text" v-else>{{$t(field.name)}}</span>
                                                </template>
                                            </v-checkbox>
                                        </v-flex>
                                    </v-layout>
                                </v-flex>

                                <v-flex xs6 grow pt-0>
                                    <v-layout column fill-height ma-0 pt-1>
                                        <v-flex v-if="getFields" v-for="(field, name) in getFields" :key="'main_'+ name" pa-0>
                                            <v-flex shrink v-show="!field.fields && field.show == 'true' && (field.type == 'select' || field.type == 'select_enum') && field.name != 'device_type' && field.name != 'dev_level' && field.place == 'main'" pl-1 pb-1 >
                                                <v-layout shrink v-if="!field.fields && field.show == 'true' && (field.type == 'select' || field.type == 'select_enum') && field.name != 'device_type' && field.name != 'dev_level' && field.place == 'main'" >
                                                    <v-flex xs5 shrink px-0 pb-2>
                                                        <v-text-field
                                                            :value="model.fields[field.name] && model.fields[field.name].required ? $t(name) + ' *' : $t(name)"
                                                            light
                                                            outline                                                
                                                            flat
                                                            readonly
                                                            disabled
                                                            class="backgrey"                                                       
                                                            hide-details
                                                            :rows="1"
                                                            color="white"
                                                        >
                                                        </v-text-field>
                                                    </v-flex>

                                                    <v-flex xs7 shrink px-0 pb-2>
                                                        <v-select :data-testid="$options.name + 'v-select' + field.name"
                                                            v-model="model.obj[field.name]"
                                                            light
                                                            :rules="model.fields[field.name] && model.fields[field.name].required ? [value => !!value || $t('required')] : []"
                                                            :items="getItems[field.cls]"
                                                            :item-text="field.type == 'select' ? 'name' : 'value'"
                                                            :item-value="field.type == 'select' ? '$id' : 'id'"
                                                            outline                                                      
                                                            hide-details
                                                            class="white"
                                                            background-color="backgrey"
                                                            :clearable="name != 'mount' && name != 'unit'"
                                                        >
                                                        <template v-slot:item="{ item, index }">
                                                            <span>{{ $t(field.type == 'select' ? item.name : item.value) }}</span>
                                                        </template>
                                                        <template v-slot:selection="{ item, index }">
                                                            <span>{{ $t(field.type == 'select' ? item.name : item.value) }}</span>
                                                        </template>
                                                        </v-select>
                                                    </v-flex>
                                                </v-layout>
                                            </v-flex>

                                            <v-flex shrink v-if="field.fields" v-for="(sfield, name) in field.fields" :key="'main_s_'+ name" pa-0>
                                                <v-flex shrink v-if="sfield.place == 'main' && (sfield.type == 'select' || sfield.type == 'select_enum')" pl-1 pb-1>
                                                    <v-layout shrink>
                                                        <v-flex xs5 shrink px-0 pb-2>
                                                            <v-text-field
                                                                :value="$t(name)"
                                                                light
                                                                outline                                                  
                                                                flat
                                                                readonly
                                                                disabled
                                                                class="backgrey"                                                         
                                                                hide-details
                                                                :rows="1"
                                                                color="grey"
                                                            >
                                                            </v-text-field>
                                                        </v-flex>

                                                        <v-flex xs7 shrink px-0 pb-2>
                                                            <v-select :data-testid="$options.name + 'v-select' + sfield.name"
                                                                v-model="model.obj[field.name][sfield.name]"
                                                                light
                                                                :items="getItems[sfield.cls]"
                                                                :item-text="sfield.type == 'select' ? 'name' : 'value'"
                                                                :item-value="sfield.type == 'select' ? '$id' : 'id'"
                                                                outline                                                       
                                                                hide-details
                                                                class="white"
                                                                background-color="backgrey"
                                                                :clearable="name != 'mount' && name != 'unit'"
                                                            >
                                                                <template v-slot:item="{ item, index }">
                                                                    <span>{{ $t(sfield.type == 'select' ? item.name : item.value) }}</span>
                                                                </template>
                                                                <template v-slot:selection="{ item, index }">
                                                                    <span>{{ $t(sfield.type == 'select' ? item.name : item.value) }}</span>
                                                                </template>
                                                            </v-select>
                                                        </v-flex>
                                                    </v-layout>
                                                </v-flex>
                                            </v-flex>
                                        </v-flex>
                                    </v-layout>
                                </v-flex>
                            </v-layout>
                        </v-form>
                    </v-layout>
                </v-layout>
        </template>
    </scroll-area>
</template>

<script lang="ts">
import Vue from 'vue'
import scrollArea from '@/nms/components/partials/scrollarea.vue'
import datePicker from '@/nms/components/controls/input-menu-datepicker.vue'

// Типы
interface InventoryData {
  $id?: string
  [key: string]: any
}

interface MetaData {
  refs?: any[]
  [key: string]: any
}

interface ModelData {
  fields?: Record<string, any>
  items?: Record<string, any>
  obj?: Record<string, any>
  refs?: Record<string, { cls?: string; id?: string; [key: string]: any }>
  [key: string]: any
}

interface CabinetData {
  [key: string]: any
}

interface ValidationResult {
  $id?: string
  valid: any
}

export default Vue.extend({
  name: 'INVENTORY',

  components: {
    scrollArea,
    datePicker
  },

  props: {
    data: {
      type: Object as () => InventoryData,
      default: () => ({})
    },
    meta: {
      type: Object as () => MetaData,
      default: () => ({})
    },
    model: {
      type: Object as () => ModelData,
      default: () => ({})
    },
    edit: {
      type: Boolean,
      default: () => false
    },
    cabinet: {
      type: Object as () => CabinetData,
      default: () => ({})
    },
    closedUnits: {
      type: Array as () => any[],
      default: () => []
    },
  },

  computed: {
    getData(): InventoryData {
      return this.data
    },
    getMeta(): MetaData {
      return this.meta
    },
    getFields(): Record<string, any> {
      return this.model.fields || {}
    },
    getItems(): Record<string, any> | undefined {
      return this.model.items
    },
    isEdit(): boolean {
      return this.edit
    },
  },

  methods: {
    setup(): void {},

    onDateChange(payload: any, fieldName: string): void {
      this.$set(this.model.obj, fieldName, payload)
    },

    showDate(date: Date): string {
      const date$ = new Date(date.getTime() - (date.getTimezoneOffset() * 60000)).toISOString()
      return date$.substring(0, 10).split('-').reverse().join('.')
    },

    validateForm(): ValidationResult {
      const formRef = this.$refs['inventory-device-form'] as any
      const v = formRef?.validate() ?? false
      console.log(this.$options.name, 'validateForm', 'v', v)
      
      const obj: Record<string, any> = {}
      Object.keys(this.model.obj || {}).forEach(key => {
        obj[key] = this.model.obj?.[key]
      })
      
      if (this.model.refs && this.meta.refs?.length) {
        const refs$: Array<{ ref: string; cls?: string; id?: string }> = []
        Object.keys(this.model.refs).forEach(ref => {
          const refItem = this.model.refs?.[ref]
          if (refItem) {
            refs$.push({
              ref: ref,
              cls: refItem.cls,
              id: refItem.id
            })
          }
        })
        obj.refs = refs$
      }
      
      return v ? { $id: this.data.$id, valid: obj } : { $id: this.data.$id, valid: v }
    },
  },
})
</script>

<style scoped>

</style>